import { render, staticRenderFns } from "./orderItemEditorViewerDialog.vue?vue&type=template&id=372a6458&"
import script from "./orderItemEditorViewerDialog.vue?vue&type=script&lang=js&"
export * from "./orderItemEditorViewerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports